import React, { useEffect, useState } from 'react';
import { Card } from '../../shared/components';
import { api } from '../../utils/api';
import './Progress.css';

export default function Progress() {
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/progress')
      .then(setProgress)
      .catch(() => setError('Unable to load your progress right now.'));
  }, []);

  if (error) return <p className="progress-error">{error}</p>;
  if (!progress) return <p>Loading your progress&hellip;</p>;

  return (
    <div className="progress-page">
      <h1>Your Progress</h1>

      <h2 className="progress-section-heading">Quizzes by domain</h2>
      <Card className="progress-table-card">
        <table className="progress-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Attempts</th>
              <th>Best</th>
              <th>Last</th>
            </tr>
          </thead>
          <tbody>
            {progress.quizzes.byTopic.map((t) => (
              <tr key={t.topic_slug}>
                <td>{t.topic_name}</td>
                <td>{t.attempts}</td>
                <td>{t.best_pct !== null ? `${t.best_pct}%` : '—'}</td>
                <td>{t.last_pct !== null ? `${t.last_pct}%` : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <h2 className="progress-section-heading">Flashcard mastery</h2>
      <Card className="progress-table-card">
        <table className="progress-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Known</th>
              <th>Needs review</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {progress.flashcards.byTopic.map((t) => (
              <tr key={t.topic_slug}>
                <td>{t.topic_name}</td>
                <td>{t.known}</td>
                <td>{t.review}</td>
                <td>{t.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <h2 className="progress-section-heading">Exam attempts</h2>
      <Card className="progress-table-card">
        {progress.exams.attempts.length === 0 ? (
          <p>No completed practice exams yet.</p>
        ) : (
          <table className="progress-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {progress.exams.attempts.map((attempt) => (
                <tr key={attempt.id}>
                  <td>{new Date(attempt.completed_at).toLocaleDateString()}</td>
                  <td>{attempt.correct_count} / {attempt.total_questions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
